export default "__VITE_ASSET___76wscnN__"